import styled, { css } from 'styled-components'

import PropTypes from 'prop-types'
import Tooltip from '@shared/components/Tooltip'

export const Container = styled.div`
  background: ${props => props.theme.foreground};
  border-radius: .5rem;

  margin-bottom: 1rem;

  position: relative;
  display: flex;
  align-items: center;

  border: solid 2px ${props => props.theme.foreground};
  color: ${props => props.theme.text};

  ${props => props.isFilled && css`
    color: ${props => props.theme.primary};
  `}

  ${props => props.hasError && css`
    border-color: ${props => props.theme.danger};
  `}

  ${props => props.isFocused && css`
    border-color: ${props => props.theme.primary};
    color: ${props => props.theme.primary};
  `}

  & + & {
    margin-top: .5rem;
  }

  label {
    position: absolute;
    top: .25rem;
    left: 1rem;
    z-index: 1;
    font-size: 10px;
    color: inherit;
    transition: opacity .5s;
    /* opacity: ${props => Number(props.isFocused || props.isFilled)} */
  }

  select {
    color: ${props => props.theme.text};
    background: transparent;
    padding: 1.125rem .75rem 1rem;
    border: 0;
    font-size: .875rem;

    flex: 1;
    height: 100%;
    width: 100%;

    &::placeholder {
      color: ${props => props.theme.text};
      transition: color .25s ease-in;
    }

    &:focus::placeholder {
      color: transparent;
    }
  }

  > svg {
    margin-right: 1rem;
  }

`

Container.propTypes = {
  isFocused: PropTypes.bool,
  isFilled: PropTypes.bool,
  hasError: PropTypes.bool
}

export const Error = styled(Tooltip)`
  margin-left: 1rem;

  span {
    background: #c53030;
    color: ${props => props.theme.white};
    &::before {
      border-color: #c53030 transparent;
    }
  }
`
Error.propTypes = {
  isFocused: PropTypes.bool
}
